import IntlMessage from "components/util-components/IntlMessage";
import AppLocale from "lang";

const setLocale = (isLocaleOn, localeKey) => isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();
export default setLocale

const setLocaleJS = (langInRoute, localeKey) => AppLocale[langInRoute].messages[localeKey]
export { setLocaleJS }